import React, { useEffect, useRef, useState } from "react";
import CircleProgressBar from "../../components/CircleProgressBar/CircleProgressBar";
import BarProgress from "../../components/BarProgress/BarProgress";
import AudioPlayer from "../../components/AudioPlayer/AudioPlayer";
import instance from "../../services/axiosInstane";
import SnackBar from "../../components/SnackBar/SnackBar";
import { useParams } from "react-router";
import {
  assessmentConfig,
  assessmentStatus,
  resultRefreshTime,
  snackbarColor,
} from "../../config/constants";
import {
  hanldingAudioErr,
  monotoneErrHandling,
  unexpectedBreakErr,
} from "../../helpers/audioErrors";
import AudioRecorder from "audio-recorder-polyfill";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import mpegEncoder from "audio-recorder-polyfill/mpeg-encoder";
import Button from "../../components/Button/Button";
import Tooltip from "../../components/Tooltip/Tooltip";
import {
  AssessmentProps,
  AudioErrorProps,
  ErrorTypeProps,
  LanguageProps,
} from "../../interfaces/Interface";
import Loader from "../../components/Loader/Loader";
import ComboBox from "../../components/ComboBox/ComboBox";
import DataTable from "../../components/DataTable/DataTable";
import AudioError from "../../components/AudioError/AudioError";
import { messages } from "../../config/messages";
import PercentageColor from "../../components/PercentageColor/PercentageColor";

const columns = [
  { id: "questionText", label: "question Text", width: 600 },
  { id: "languageName", label: "Language", width: 150 },
  { id: "createdDate", label: "created Date", width: 200 },
  { id: "status", label: "status", width: 100 },
  { id: "results", label: "Result", width: 150 },
];

AudioRecorder.encoder = mpegEncoder;
AudioRecorder.prototype.mimeType = "audio/mpeg";
window.MediaRecorder = AudioRecorder;

const Reading = () => {
  const divRef = useRef<HTMLDivElement>(null);
  const { userId } = useParams<string>();
  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const audioChunks = useRef<Array<Blob>>([]);
  const [audio, setAudio] = useState<string>("");

  const [indexing, setIndexing] = useState<number>(0);
  const [text, setText] = useState<string>("");
  const [ownText, setOwnText] = useState<string>("");
  const [snackBarOpen, setSnackBarOpen] = useState({
    value: false,
    message: "",
    type: "",
  });
  const [languageResponse, setLanguageResponse] = useState([
    {
      language: "",
      languageName: "",
      sampleQuestions: [],
    },
  ]);
  const [currentLanguage, setCurrentLanguage] = useState([
    {
      id: "en-IN",
      name: "English (India)",
    },
  ]);
  const [selectedLanguage, setSelectedLanguage] = useState({
    id: "en-IN",
    name: "English (India)",
  });
  const [assessmentResponse, setAssessmentResponse] = useState<
    AssessmentProps[]
  >([]);
  const [showInfo, setShowInfo] = useState(false);
  const [questionId, setQuestionId] = useState("");
  const [scoreBreakdown, setScoreBreakdown] = useState({
    accuracyScore: 0,
    completenessScore: 0,
    fluencyScore: 0,
    prosodyScore: 0,
  });
  const [audioErrorType, setAudioErrorType] = useState<any>([]);
  const [myAudio, setMyAudio] = useState<any>(null);
  const recorderRef = useRef<any>();
  const [uploadedAudioFile, setUploadedAudioFile] = useState<File | null>(null);
  const [serverAudioFile, setServerAudioFile] = useState<any>(null);
  const [audioSelected, setAudioSelected] = useState<string>("");
  const [errorWordColor, setErrorWordColor] = useState<AudioErrorProps[]>([
    {
      word: "",
      error: "",
      monoErr: "",
      unExpBreak: "",
      missingBreak: "",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const streamRef = useRef<any>();
  const [isRecordingTouched, setIsRecordingTouched] = useState(false);
  const timeoutInterval = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [showPronunciationInfo, setShowPronunciationInfo] = useState(false);
  const [showErrorInfo, setShowErrorInfo] = useState<number | null>(null);
  const [seconds, setSeconds] = useState<number>(0);
  const timerCountInterval = useRef<ReturnType<typeof setInterval>>();
  const fileUploadRef = useRef<HTMLInputElement | null>(null);

  const errorTypes = [
    {
      id: 1,
      text: "Mispronunciations",
      color: "bg-yellow-500",
      value: hanldingAudioErr(audioErrorType).mispronuciationsCount,
      title: `The words that are spoken incorrectly.`,
    },
    {
      id: 2,
      text: "Omissions",
      color: "bg-gray-500",
      value: hanldingAudioErr(audioErrorType).omissionCount,
      title: `The words that are provided in the script but are not spoken.`,
    },
    {
      id: 3,
      text: "Insertions",
      color: "bg-red-500",
      value: hanldingAudioErr(audioErrorType).insertionCount,
      title: `
      The words that are not in the script but are detected in the recording.`,
    },
    {
      id: 4,
      text: "Unexpected break",
      color: "bg-pink-500",
      value: unexpectedBreakErr(audioErrorType),
      title: `Improperly paused in between words within same sentence`,
    },
    {
      id: 5,
      text: "Missing break",
      color: "bg-gray-300",
      value: hanldingAudioErr(audioErrorType).missingBreakCount,
      title: `Missing pauses between words when there is a punctuation in present between them.`,
    },
    {
      id: 6,
      text: "Monotone",
      color: "bg-blue-500",
      value: monotoneErrHandling(audioErrorType),
      title: `The words are being read in a flat and unexciting tone, without any rhythm or expression.`,
    },
  ];

  const toggleErrorInfoClick = (index: number) => {
    setShowErrorInfo(showErrorInfo === index ? null : index);
  };

  useEffect(() => {
    getAssessment();
    getLanguages();
  }, []);

  useEffect(() => {
    assessmentResponse.map((assessment: AssessmentProps) => {
      if (
        assessment.status === assessmentStatus.pending ||
        assessment.status === assessmentStatus.processing
      ) {
        setTimeout(() => {
          getAssessment();
        }, resultRefreshTime.twoSeconds);
      }
    });
  }, [assessmentResponse]);

  useEffect(() => {
    // This code will run after `state` is set
    if (showInfo) {
      // Perform your action here
      if (divRef.current) {
        divRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [showInfo, questionId]);

  const handleRecordAudio = async () => {
    if (text === "" && ownText === "") {
      setSnackBarOpen({
        ...snackBarOpen,
        value: true,
        message: "Please select or enter a text.",
        type: snackbarColor.warning,
      });
    } else {
      if (audioSelected !== "uploaded") {
        if (recordingStatus === "inactive") {
          let audioChunksLoaded: Array<Blob> = [];
          if (isRecordingTouched) {
            recorderRef.current.start();
            timeoutInterval.current = setTimeout(() => {
              recorderRef.current?.stop();
            }, 5000);
            timerCountInterval.current = setInterval(() => {
              setSeconds((prev) => prev + 1);
            }, 1000);
            setRecordingStatus("recording");
          } else {
            navigator.mediaDevices
              .getUserMedia({
                audio: true,
                video: false,
              })
              .then((stream) => {
                recorderRef.current = new MediaRecorder(stream);
                recorderRef.current.start();
                timeoutInterval.current = setTimeout(() => {
                  recorderRef.current?.stop();
                }, 5000);
                timerCountInterval.current = setInterval(() => {
                  setSeconds((prev) => prev + 1);
                }, 1000);
                setRecordingStatus("recording");
                setIsRecordingTouched(true);

                recorderRef.current.addEventListener(
                  "dataavailable",
                  (event: { data: Blob }) => {
                    audioChunksLoaded.push(event.data);
                    audioChunks.current = [...audioChunksLoaded];
                  }
                );

                recorderRef.current.addEventListener("stop", async () => {
                  clearTimeout(
                    timeoutInterval.current as ReturnType<typeof setTimeout>
                  );
                  clearInterval(
                    timerCountInterval.current as ReturnType<typeof setInterval>
                  );
                  const audioBlob = new Blob(audioChunks.current, {
                    type: "audio/mpeg",
                  });
                  audioChunks.current = [];
                  audioChunksLoaded = [];
                  const fileAudioBlob = new File([audioBlob], "my-audio.mp3", {
                    type: "audio/mpeg",
                  });
                  //creates a playable URL from the blob file.
                  setServerAudioFile(fileAudioBlob);
                  const audioUrl = URL.createObjectURL(audioBlob);
                  setAudio(audioUrl);
                  setRecordingStatus("inactive");
                  setAudioSelected("recorded");
                  setSeconds(0);
                  setSnackBarOpen({
                    ...snackBarOpen,
                    value: true,
                    message:
                      "Recording has been completed, please click on Submit OR Reset to try again.",
                    type: snackbarColor.success,
                  });
                  streamRef.current = stream;
                });
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else if (recordingStatus === "recording") {
          recorderRef.current.stop();
        }
      } else {
        return;
      }
    }
  };

  const onClickText = (item: string, index: number) => {
    setIndexing(index);
    setText(item);
    setOwnText("");
  };
  const handleOwnText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOwnText(e.target.value);
    setIndexing(-1);
    setText("");
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("filechange");
    document.getElementById("ds")?.focus();
    const file = event.target.files && event.target.files[0];
    setUploadedAudioFile(file);
    setAudioSelected("uploaded");
  };

  const getLanguages = async () => {
    await instance
      .get("assessments/languages")
      .then((responce) => {
        setLanguageResponse(responce.data.reading);
        setText(responce.data?.reading[0]?.sampleQuestions[0]);
        setCurrentLanguage(
          responce.data.reading?.map((item: LanguageProps) => {
            return {
              id: item.language,
              name: item.languageName,
            };
          })
        );
      })
      .catch((e) => {
        console.log(e.response.data.message, "error");
      });
  };

  const postAssessment = async () => {
    setIsLoading(true);
    const question = text !== "" ? text : ownText;
    const formData = new FormData();
    formData.append("UserId", userId as string);
    formData.append(
      "AudioFile",
      audioSelected === "recorded" ? serverAudioFile : uploadedAudioFile
    );
    formData.append("Type", "Reading");
    formData.append("QuestionText", question);
    formData.append("Language", selectedLanguage.id);

    await instance
      .post("/assessments", formData)
      .then((response) => {
        if (response.status === 201) {
          getAssessment();
          setSnackBarOpen({
            ...snackBarOpen,
            value: true,
            message: messages.submitAudio,
            type: snackbarColor.success,
          });
          setUploadedAudioFile(null);
          setServerAudioFile(null);
          setAudioSelected("");
          setAudio("");
        }
      })
      .catch((e) => {
        setSnackBarOpen({
          ...snackBarOpen,
          value: true,
          message: e.response.data.message || messages.somethingWentWrong,
          type: snackbarColor.error,
        });
        setIsLoading(false);
      });
  };

  const getAssessment = async () => {
    const obj: { userId: string; type: string } = {
      userId: userId as string,
      type: "Reading",
    };
    await instance
      .get(`/assessments`, { params: obj })
      .then((response) => {
        setAssessmentResponse(response?.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "error");
        setSnackBarOpen({
          ...snackBarOpen,
          value: true,
          message: messages.somethingWentWrong,
          type: snackbarColor.error,
        });
        setIsLoading(false);
      });
  };

  const showDetails = (item: AssessmentProps) => {
    setShowInfo(true);
    setQuestionId(item.id);
    getAssessmentResult(item);
    setMyAudio(item.audioFile);
  };

  const getAssessmentResult = async (item: AssessmentProps) => {
    setIsLoading(true);
    await instance
      .get(`/assessments/${item.id}/result`)
      .then((response) => {
        if (response.status === 200) {
          gotResultResponse(response.data);
        }
      })
      .catch((e) => {
        setSnackBarOpen({
          ...snackBarOpen,
          value: true,
          message: messages.somethingWentWrong,
          type: snackbarColor.error,
        });
        setIsLoading(false);
      });
  };

  const gotResultResponse = async (data: any) => {
    setScoreBreakdown({
      accuracyScore: data.NBest[0].PronunciationAssessment.AccuracyScore,
      completenessScore:
        data.NBest[0].PronunciationAssessment.CompletenessScore,
      fluencyScore: data.NBest[0].PronunciationAssessment.FluencyScore,
      prosodyScore: data.NBest[0].PronunciationAssessment.PronScore,
    });
    setAudioErrorType(data.NBest[0].Words);
    setErrorWordColor(
      data.NBest[0]?.Words?.map((wordObj: any) => ({
        word: wordObj?.Word,
        error: wordObj?.PronunciationAssessment?.ErrorType,
        monoErr:
          wordObj?.PronunciationAssessment?.Feedback?.Prosody?.Intonation
            ?.ErrorTypes[0],
        unExpBreak:
          wordObj?.PronunciationAssessment?.Feedback?.Prosody?.Break
            ?.ErrorTypes[0] === "UnexpectedBreak"
            ? wordObj?.PronunciationAssessment?.Feedback?.Prosody?.Break
                ?.ErrorTypes[0]
            : undefined,
        missingBreak:
          wordObj?.PronunciationAssessment?.Feedback?.Prosody?.Break
            ?.ErrorTypes[0] === "MissingBreak"
            ? wordObj?.PronunciationAssessment?.Feedback?.Prosody?.Break
                ?.ErrorTypes[0]
            : undefined,
      }))
    );
    setIsLoading(false);
  };

  const getParcentage = () => {
    const sum =
      scoreBreakdown.accuracyScore +
      scoreBreakdown.completenessScore +
      scoreBreakdown.fluencyScore +
      scoreBreakdown.prosodyScore;
    const result = sum / 400;
    return result * 100;
  };

  const handleSelectionChange = (
    _e: React.ChangeEvent,
    newValue: { id: string; name: string } | null
  ) => {
    if (newValue !== null) {
      setSelectedLanguage(newValue);
    }
    setText(
      languageResponse.filter(
        (item: LanguageProps) => item?.language === newValue?.id
      )[0]?.sampleQuestions[0]
    );
    setIndexing(0);
    setOwnText("");
  };

  const handleReset = () => {
    setAudioSelected("");
    setRecordingStatus("inactive");
    setAudio("");
    setServerAudioFile(null);
    setUploadedAudioFile(null);
    audioChunks.current = [];
  };

  const validation = () => {
    if (ownText === "" && text === "") {
      setSnackBarOpen({
        ...snackBarOpen,
        value: true,
        message: messages.selectText,
        type: snackbarColor.error,
      });
    } else if (serverAudioFile === null && uploadedAudioFile === null) {
      setSnackBarOpen({
        ...snackBarOpen,
        value: true,
        message: messages.recordAudio,
        type: snackbarColor.error,
      });
    } else {
      postAssessment();
    }
  };

  const disableText = (index: number) => {
    if (
      serverAudioFile !== null ||
      (recordingStatus === "recording" && indexing !== index) ||
      (uploadedAudioFile !== null && indexing !== index)
    ) {
      return "bg-gray-300 pointer-events-none";
    }
  };

  const hideResult = () => {
    setShowInfo(false);
    setQuestionId("");
  };

  const handleLabelInputClick = (
    event:
      | React.MouseEvent<HTMLDivElement>
      | React.KeyboardEvent<HTMLDivElement>
  ) => {
    fileUploadRef.current?.click();
  };

  return (
    <div className="w-full">
      {isLoading ? <Loader /> : null}
      {assessmentResponse.length < assessmentConfig.AssessmentCountLimit ? (
        <section>
          <div className="w-full mb-2 flex flex-col-reverse md:flex-row sm:flex-col-reverse items-end md:items-center justify-end md:justify-between">
            <div className="mb-2 w-full">
              {" "}
              <div className="text-sm text-gray-700 mb-1">
                Choose a language
              </div>
              <div className="md:w-[250px] w-full  ">
                <ComboBox
                  obj={currentLanguage}
                  handleChange={handleSelectionChange}
                  value={selectedLanguage}
                  disable={recordingStatus === "recording"}
                />{" "}
              </div>
            </div>
            <div className="flex justify-start items-center mt-0 md:mt-2 ">
              {audioSelected && (
                <div className="mr-2">
                  <Button onClick={handleReset} type={"button"} label="Reset" />
                </div>
              )}
              <Button
                onClick={validation}
                disable={false}
                type={"button"}
                label="Submit"
              />
            </div>
          </div>
          <div className="text-[12px] sm:text-sm text-gray-700 mb-2">
            <div>
              <h1
                className="font-semibold"
                aria-label="Select one of the sample texts or enter your own text and click
                record button or upload the recorded audio."
              >
                {" "}
                Select one of the sample texts or enter your own text and click
                record button or upload the recorded audio.
              </h1>
              <div className=" bg-gray-100 p-1 rounded-sm">
                <div className=" text-gray-700 font-semibold">
                  {`[You can try upto 5 attempts.]`}
                </div>
              </div>
            </div>
          </div>

          <div className="lg:flex lg:space-x-4 justify-between w-full">
            <div className="w-full">
              <div className="w-full flex flex-col justify-between items-center">
                {languageResponse
                  ?.filter(
                    (item: LanguageProps) =>
                      item?.language === selectedLanguage.id
                  )[0]
                  ?.sampleQuestions?.map((item: string, index: number) => {
                    return (
                      <div
                        onClick={() => onClickText(item, index)}
                        onKeyDown={(
                          event: React.KeyboardEvent<HTMLDivElement>
                        ) => {
                          if (event.key === "Enter" || event.code == "Space") {
                            onClickText(item, index);
                          }
                        }}
                        key={index}
                        tabIndex={0}
                        className={`shadow-sm ${disableText(
                          index
                        )} flex items-center border w-full p-2 rounded-sm justify-between cursor-pointer mb-2 ${
                          indexing === index
                            ? `bg-blue-100 font-semibold text-[blue]`
                            : `text-gray-500 `
                        } `}
                      >
                        <div className="text-[12px] sm:text-sm">{item}</div>
                        <div>
                          <i
                            className={`${
                              indexing === index
                                ? `fa-regular fa-circle-check`
                                : `fa-regular fa-circle`
                            } text-lg`}
                          ></i>
                        </div>
                      </div>
                    );
                  })}
              </div>

              <div
                onClick={() => {
                  setIndexing(-1);
                  setText("");
                }}
                className="shadow-sm relative flex items-center border w-full mt-0 rounded-sm text-black justify-between focus:border-red-500"
              >
                <input
                  type="text"
                  className={` ${
                    ownText.length > 0 ? `bg-blue-100` : `bg-white`
                  } sm:text-sm text-[12px] w-full p-3 outline-none focus:bg-blue-100 disabled:bg-gray-300 `}
                  placeholder="Enter your own text"
                  value={ownText}
                  onChange={handleOwnText}
                  maxLength={100}
                  disabled={
                    serverAudioFile !== null ||
                    recordingStatus === "recording" ||
                    uploadedAudioFile !== null
                  }
                />
              </div>
            </div>
            <div className="sm:flex-col md:flex lg:flex-col justify-between mt-2 lg:mt-0 space-y-2 leading-6	">
              <div className="p-1 border border-dashed bg-gray-100 lg:h-[125px]  lg:w-[400px] w-full flex items-center justify-center rounded-sm">
                <div className="w-full h-full lg:flex flex lg:flex-row text-center lg:text-left flex-col items-center justify-center text-[12px] font-semibold lg:space-x-6 px-6">
                  <div className="flex flex-col justify-center items-center">
                    <div
                      aria-label="Microphone"
                      className={`bg-gray-500 p-2 w-12 h-12 flex items-center justify-center rounded-full mb-2 ${
                        uploadedAudioFile !== null
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                      onClick={handleRecordAudio}
                      style={{
                        backgroundColor:
                          recordingStatus === "inactive" ? "gray" : "red",
                      }}
                      tabIndex={0}
                      onKeyDown={(
                        event: React.KeyboardEvent<HTMLDivElement>
                      ) => {
                        if (event.key === "Enter" || event.code == "Space") {
                          handleRecordAudio();
                        }
                      }}
                      role="button"
                    >
                      {recordingStatus === "recording" && (
                        <i className="fa-solid fa-circle-stop text-white text-[20px]"></i>
                      )}

                      {recordingStatus === "inactive" && (
                        <i className="fa-solid fa-microphone text-[20px] text-white"></i>
                      )}
                    </div>
                    {recordingStatus === "recording" && (
                      <div>{seconds !== 5 && `0${seconds}s`}</div>
                    )}
                  </div>

                  <div className="font-normal">
                    <div className="font-semibold">Click here to</div>
                    <div className="text-black">
                      Record audio with a microphone
                    </div>
                    <div className="text-black">
                      Start speaking once the mic turns red
                    </div>
                    <div className="font-semibold">{`[Time limit is ${assessmentConfig.ReadingAudioDurationLimitInSec} seconds]`}</div>
                  </div>
                </div>
              </div>

              <div
                className={`p-1 relative border border-dashed ${
                  serverAudioFile !== null || recordingStatus === "recording"
                    ? "bg-gray-300"
                    : "bg-gray-100"
                } h-full lg:h-[125px] lg:w-[400px] w-full flex items-center justify-center rounded-sm`}
                onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                  if (event.key === "Enter" || event.code == "Space") {
                    handleLabelInputClick(event);
                  }
                }}
                onClick={(event: React.MouseEvent<HTMLDivElement>) =>
                  handleLabelInputClick(event)
                }
                tabIndex={0}
              >
                <div className="w-full flex flex-col lg:flex-row  items-center text-center lg:text-left text-[12px] font-semibold lg:space-x-6 px-8">
                  <div className="lg:ml-4 ml-0 bg-gray-500 p-2 w-12 h-12 flex items-center justify-center rounded-full mb-2 ">
                    <i className="fa-solid fa-cloud-arrow-up text-white text-[22px]"></i>
                  </div>
                  <div>
                    <div className="font-normal">
                      Drag and drop audio file here or
                    </div>
                    <div className="text-sm underline text-blue-500 font-normal">
                      Browse for a file {uploadedAudioFile?.name}
                    </div>
                    <div>{`[Time limit is ${assessmentConfig.ReadingAudioDurationLimitInSec} seconds]`}</div>
                    <div>{`[only .mp3, .wav files are allowed]`}</div>
                  </div>
                </div>
                <input
                  type="file"
                  accept="audio/mpeg, audio/wav"
                  onChange={handleFileChange}
                  disabled={audioSelected === "recorded"}
                  className={`hidden ${
                    serverAudioFile !== null || recordingStatus === "recording"
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                  }`}
                  aria-label="Browse a file to upload"
                  ref={fileUploadRef}
                />{" "}
              </div>
            </div>
          </div>

          <div className="mb-3">
            {audio && <AudioPlayer audioTrack={audio} />}
          </div>
        </section>
      ) : (
        <div className="w-full bg-gray-100 border border-gray-300 rounded-sm p-4 mb-4">
          <div className="text-sm">
            You have reached the maximum assessment limit!
          </div>
        </div>
      )}
      <h2
        className="font-semibold mt-4 text-sm sm:text-md"
        aria-label="Attempts and Results"
      >
        Attempts and Results
      </h2>
      <div>
        <DataTable
          columns={columns}
          rowData={assessmentResponse}
          onViewHandler={showDetails}
          questionId={questionId}
        />
      </div>

      {showInfo && (
        <div ref={divRef}>
          <div className="flex items-center justify-between text-sm mb-2">
            <div className="font-semibold ">Assessment Result</div>
            <div className="mt-2">
              <Button
                onClick={hideResult}
                type={"button"}
                label="Hide Result"
              />
            </div>
          </div>
          <div className="w-full mb-4 mt-4">
            {myAudio && (
              <AudioPlayer
                audioTrack={`${process.env.REACT_APP_API_BASEURL}/${myAudio}`}
              />
            )}
          </div>
          <div className="border sm:flex justify-between w-full">
            <div className="w-3/4 p-4 text-sm">
              <div className="flex flex-wrap space-x-1 text-lg">
                {errorWordColor?.map((item: AudioErrorProps, index: number) => {
                  return <AudioError key={index} item={item} />;
                })}
              </div>
            </div>
            <div className="text-[12px] p-4 border-t sm:border-l sm:w-[250px] w-full">
              <div className="font-semibold mb-2">Types of Errors</div>
              {errorTypes.map((errorType: ErrorTypeProps, index: number) => {
                return (
                  <div
                    className="flex items-center space-x-3 mb-2"
                    key={errorType.id}
                  >
                    <div
                      className={`w-4 text-[10px] min-w-[10px] ${errorType.color} flex items-center justify-center  rounded-sm font-semibold text-white`}
                    >
                      {errorType.value}
                    </div>
                    <div className="font-medium">{errorType.text}</div>
                    <Tooltip
                      open={showErrorInfo === index}
                      handleClose={() => toggleErrorInfoClick(-1)}
                      handleOpen={() => toggleErrorInfoClick(index)}
                      text={errorType.title}
                      aria-label={`${errorType.title}`}
                      tabIndex={0}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="border-x border-b p-4 sm:flex w-full justify-between">
            <div className="flex flex-col sm:w-1/4 items-center w-full ">
              <div className="font-semibold text-lg flex items-center space-x-3">
                <div> Pronunciation score </div>
                <Tooltip
                  open={showPronunciationInfo}
                  handleClose={() => setShowPronunciationInfo(false)}
                  handleOpen={() => setShowPronunciationInfo(true)}
                  text={`
                    Overall score indicating the pronunciation quality of the given speech. This is aggregated from AccuracyScore, FluencyScore, CompletenessScore (if applicable), ProsodyScore (if applicable) with weight.`}
                  aria-label="Overall score indicating the pronunciation quality of the given speech. This is aggregated from AccuracyScore, FluencyScore, CompletenessScore (if applicable), ProsodyScore (if applicable) with weight."
                  tabIndex={0}
                />
              </div>
              <CircleProgressBar
                percentage={getParcentage()}
                circleWidth={150}
              />
              <PercentageColor />
            </div>
            <div className=" flex flex-col sm:w-3/4 items-center w-full ">
              <div className="font-semibold text-md mt-1">Score breakdown</div>
              <div className="lg:flex lg:space-x-7  ">
                <div>
                  <div className="w-full my-8">
                    <BarProgress
                      label={"Accuracy score"}
                      score={scoreBreakdown.accuracyScore}
                      text={`
                      Pronunciation accuracy of the speech. Accuracy indicates how closely the phonemes match a native speaker's pronunciation. Word and full text accuracy scores are aggregated from phoneme-level accuracy score.`}
                    />
                  </div>
                  <div className="w-full">
                    <BarProgress
                      label={"Fluency score"}
                      score={scoreBreakdown.fluencyScore}
                      text={`
                        Fluency of the given speech. Fluency indicates how closely the speech matches a native speaker's use of silent breaks between words.`}
                    />
                  </div>
                </div>
                <div>
                  <div className="w-full my-8">
                    <BarProgress
                      label={"Completeness score"}
                      score={scoreBreakdown.completenessScore}
                      text={`Completeness of the speech, calculated by the ratio of pronounced words to the input reference text.`}
                    />
                  </div>
                  <div className="w-full">
                    <BarProgress
                      label={"Prosody score"}
                      score={scoreBreakdown.prosodyScore}
                      text={`
                        Prosody of the given speech. Prosody indicates how nature of the given speech, including stress, intonation, speaking speed and rhythm.`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <SnackBar
        isOpen={snackBarOpen.value}
        handleClose={() => setSnackBarOpen({ ...snackBarOpen, value: false })}
        message={snackBarOpen.message}
        type={snackBarOpen.type}
      />
    </div>
  );
};

export default Reading;
